import React from 'react'
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import { detailsColumn } from '../../constants/downloadsColumn'
import { MONTH_OPTIONS } from '../../constants'

const DetailsModal = ({ onClose, data = {} }) => {

  const getMonthLabel = num => {
    const match = MONTH_OPTIONS.find(m => m.value === num)
    return match ? match.label : num
  }

  const renderValue = (colId, val) => {
    if (Array.isArray(val)) {
      const formatted =
        colId === 'months'
          ? val.map(v => getMonthLabel(v))
          : val.map(v => String(v))

      return formatted.join(', ')
    }

    if (typeof val === 'string' && val.includes(',')) {
      return val
        .split(',')
        .map(v => v.trim())
        .join(', ')
    }

    return val || '-'
  }

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        maxWidth: 'sm',
        width: '100%',
        mx: 'auto',
        position: 'relative',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 3,
          pt: 3,
          pb: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: '20px',
            fontWeight: 500,
            color: '#333333',

          }}
        >
          Details
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: '#666666',
            padding: '4px',
            '&:hover': { backgroundColor: '#f5f5f5' },
          }}
        >
          <CloseIcon sx={{ fontSize: '20px' }} />
        </IconButton>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          px: 2,
          pb: 2,
        }}
      >
        <TableContainer
          component={Paper}
          className="hide-scrollbar"
          sx={{
            boxShadow: 'none',
            borderLeft: '1px solid #DDDDDD',
            borderRight: '1px solid #DDDDDD',
            borderRadius: '8px',
            flex: 'none',
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: '#474747',
                    color: '#ffffff',
                  }}
                >
                  Parameter
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: '#474747',
                    color: '#ffffff',
                  }}
                >
                  Value
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {detailsColumn.map(col => (
                <TableRow key={col.id}>
                  <TableCell
                    sx={{ borderRight: '1px solid #ddd', width: col.width }}
                  >
                    {col.label}
                  </TableCell>
                  <TableCell>
                    {renderValue(col.id, data[col.id])}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}

export default DetailsModal
